import { Button, Modal, Form, Row, Col, Input } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import updateContact from "../../../../services/updateContact";

export default function UpdateCustomer({
  isVisible,
  customer,
  setUpdateModal,
}: any) {
  const [isLoading, setLoading] = useState(false);
  const { record } = customer;

  const [selected, setSelected] = useState(record?.type);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.validateFields();
    const data = { ...values, type: selected };
    const response = await updateContact({ data, contactId: record?._id });
    hideModal();
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const hideModal = () => {
    setUpdateModal(false);
  };

  const types = [
    { id: 1, name: "Company" },
    { id: 2, name: "Individual" },
  ];

  useEffect(() => {
    form.resetFields();
    setSelected(record?.type);
  }, [customer]);

  return (
    <Modal
      visible={isVisible}
      title="Update Customer"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createCustomer"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createCustomer"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          {types.map((type: any) => (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <button
                type="button"
                className="flex flex-row  items-center mb-4 border w-full"
                onClick={() => setSelected(type.id)}
              >
                {selected === type.id ? (
                  <div className="h-8 w-8 border-r flex justify-center items-center bg-green-100">
                    <AiOutlineCheck />
                  </div>
                ) : (
                  <div className="h-8 w-8 border-r flex justify-center items-center">
                    <AiOutlineCheck color="#FFFFFF" />
                  </div>
                )}
                <div className="ml-4"></div>
                {type.name}
              </button>
            </Col>
          ))}
        </Row>

        {selected === 1 ? (
          <>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="name"
                  initialValue={record?.company?.name}
                  rules={[
                    {
                      required: true,

                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="address"
                  initialValue={record?.company?.address}
                  rules={[
                    {
                      required: false,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="email"
                  initialValue={record?.company?.email}
                  rules={[
                    {
                      required: false,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input placeholder="Email (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="phone"
                  initialValue={record?.company?.phone}
                  rules={[
                    {
                      required: false,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="revenue"
                  initialValue={record?.company?.revenue}
                  rules={[
                    {
                      required: false,
                      message: "Please enter revenue",
                    },
                  ]}
                >
                  <Input placeholder="Revenue (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="employees"
                  initialValue={record?.company?.employees}
                  rules={[
                    {
                      required: false,
                      message: "Please enter employees",
                    },
                  ]}
                >
                  <Input placeholder="Employees (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="tin"
                  initialValue={record?.company?.tin}
                  rules={[
                    {
                      required: false,
                      message: "Please enter TIN",
                    },
                  ]}
                >
                  <Input placeholder="TIN (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="vrn"
                  initialValue={record?.company?.vrn}
                  rules={[
                    {
                      required: false,
                      message: "Please enter VRN",
                    },
                  ]}
                >
                  <Input placeholder="VRN (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="website"
                  initialValue={record?.company?.website}
                  rules={[
                    {
                      required: false,
                      message: "Please enter website",
                    },
                  ]}
                >
                  <Input placeholder="Website (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="year"
                  initialValue={record?.company?.year}
                  rules={[
                    {
                      required: false,
                      message: "Please enter year",
                    },
                  ]}
                >
                  <Input placeholder="Year (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <div className="mb-4 flex justify-center items-center font-bold">
              Owner Details
            </div>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerName"
                  initialValue={record?.company?.owner?.name}
                  rules={[
                    {
                      required: false,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerAddress"
                  initialValue={record?.company?.owner?.address}
                  rules={[
                    {
                      required: false,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerEmail"
                  initialValue={record?.company?.owner?.email}
                  rules={[
                    {
                      required: false,
                      message: "Please enter email (Optional)",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerPhone"
                  initialValue={record?.company?.owner?.phone}
                  rules={[
                    {
                      required: false,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone (Optional)" />
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="name"
                  initialValue={record?.person?.name}
                  rules={[
                    {
                      required: true,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="address"
                  initialValue={record?.person?.address}
                  rules={[
                    {
                      required: false,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="email"
                  initialValue={record?.person?.email}
                  rules={[
                    {
                      required: false,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input placeholder="Email (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="phone"
                  initialValue={record?.person?.phone}
                  rules={[
                    {
                      required: false,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone (Optional)" />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
}
